import store from '@/store';

/**
 * 判读是否是只读权限
 * @param {Element} el 指令绑定的元素
 * @param {Object} binding 指令的信息
 */
function checkReadOnlyPermission(el, binding) {
  const { value } = binding;
  const readOnly = store.state.readOnly;
  if (value && value instanceof Array) {
    if (value.length > 0) {
      const readOnlyPermission = value;
      const hasReadOnlyPermission = readOnly.some(role => {
        return readOnlyPermission.includes(role);
      });
      // 只读
      if (hasReadOnlyPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  }
}

export default {
  inserted(el, binding) {
    checkReadOnlyPermission(el, binding);
  },
  update(el, binding) {
    checkReadOnlyPermission(el, binding);
  }
};